import { render, staticRenderFns } from "./ExtraPackaging.vue?vue&type=template&id=6e311016&"
import script from "./ExtraPackaging.vue?vue&type=script&lang=js&"
export * from "./ExtraPackaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports